module.exports = __webpack_public_path__ + "static/media/skoteino-nepal-bg.8baf25f1.jpg";